var map = {
	"./cartao_amex.png": "7c3b",
	"./cartao_aura.png": "0e83",
	"./cartao_banescard.png": "007f",
	"./cartao_cabal.png": "e840",
	"./cartao_diners.png": "7456",
	"./cartao_discover.png": "f33c",
	"./cartao_elo.png": "6c40",
	"./cartao_hipercard.png": "ad2a",
	"./cartao_jcb.png": "74fc",
	"./cartao_maestro.png": "c241",
	"./cartao_mastercard.png": "3ed9",
	"./cartao_visa.png": "e0e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "481a";